import { render } from "./ServicesOverview.vue?vue&type=template&id=35f6d686"
import script from "./ServicesOverview.vue?vue&type=script&lang=js"
export * from "./ServicesOverview.vue?vue&type=script&lang=js"

import "./ServicesOverview.vue?vue&type=style&index=0&id=35f6d686&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__